"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormDatePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _SingleDatePickerUi = require("../../SingleDatePickerUi");
var _Tooltip = require("../../Tooltip");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var FormDatePicker = _ref => {
  var {
    id,
    value,
    onChange = () => {
      return;
    },
    errors,
    name,
    errorIcon,
    locale,
    calendarLabels,
    icons,
    placeholder,
    disableMonthBefore,
    disableMonthAfter,
    disableDays,
    containerClassName,
    buttonClassName
  } = _ref;
  var [date, setDate] = (0, _react.useState)(value);
  var [currentMonthStart, setCurrentMonthStart] = (0, _react.useState)(new Date());
  var error = errors === null || errors === void 0 ? void 0 : errors[name];
  var hasError = !!(error !== null && error !== void 0 && error.type);
  var handleDateChange = newDate => {
    setDate(newDate);
    onChange(newDate);
  };
  return (0, _jsxRuntime.jsxs)("div", {
    className: containerClassName,
    children: [(0, _jsxRuntime.jsx)(_SingleDatePickerUi.SingleDatePickerUi, {
      fromMonth: disableMonthBefore,
      toMonth: disableMonthAfter,
      selectedDay: date,
      currentMonth: currentMonthStart,
      setCurrentMonth: setCurrentMonthStart,
      className: datePickerStyle,
      locale: locale,
      formLabels: calendarLabels,
      icons: icons,
      onDateChange: value => {
        handleDateChange(value);
      },
      showError: hasError ? 'error' : undefined,
      placeholder: placeholder,
      disabled: disableDays,
      buttonClassName: buttonClassName
    }), (0, _jsxRuntime.jsx)(_Tooltip.ErrorTooltip, {
      icon: errorIcon,
      content: error === null || error === void 0 ? void 0 : error.message,
      open: hasError,
      testId: "".concat(id, "-Error-Tooltip"),
      className: "!flex ib-word-break",
      mobile: true
    })]
  });
};
exports.FormDatePicker = FormDatePicker;
var datePickerStyle = 'max-h-[3.5rem]';